import { refreshAuthLogic, jsonHeader } from "../fetchTools";

import axios from 'axios';

export const getDataBerita = async () => {
    try {
        const res = await fetch('https://documentsolution.com/api/berita', {
            method: 'GET',
            // mode: 'cors'
            // ...jsonHeader()
        })

        var data = await res.json()
        // console.log(data)
        return {status: res.status, data: data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }


}   